import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class OpeningHoursDay {

  public isClosed: boolean | null = null;

  public nightPercentage: number | null = null;

  public openingHour: number | null = null;

  public closingHour: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);
  }
}
